import { GAME_ID, GAME_IDS, LANDING_PAGE_GAME_ID } from '../../constants';
import { ASYNC_RESOURCE_LOADED, GAME_SELECTED, GAME_CONTINUE, GAME_TIMELIMIT } from './types';
/**
 * Initial state
 */
// Default game ID comes from constant
let gameId = LANDING_PAGE_GAME_ID;
// For reloading page, load and set gameId from params if exists
if (typeof window !== `undefined`) {
  const queryParams = new URLSearchParams(window.location.search);
  const gameIdInParams = queryParams.get(GAME_ID);
  if (gameIdInParams && GAME_IDS.indexOf(gameIdInParams) > -1) {
    gameId = gameIdInParams;
  }
}

const initialState = {
  gameId,
  loadedResources: {},
  isContinue :false
};

/**
 * Auth redux reducer
 */
export default (state = initialState, action) => {
  switch (action.type) {
    case ASYNC_RESOURCE_LOADED: {
      return {
        ...state,
        loadedResources: {
          [action.resource]: true,
          ...state.loadedResources
        }
      };
    }
    case GAME_SELECTED: {
      return {
        ...state,
        gameId: action.gameId
      };
    }
    case GAME_CONTINUE: {
      return {
        ...state,
        isContinue: action.isContinue
      };
    }
    case GAME_TIMELIMIT: {
      return {
        ...state,
        timeLimit: action.timeLimit
      };
    }
    default:
      return state;
  }
};
